(function () {
    'use strict';
    angular
        .module('portalApp')
        .factory('YieldCurveData', YieldCurveData);

    YieldCurveData.$inject = ['$resource', 'DateUtils'];

    function YieldCurveData($resource, DateUtils) {
        var resourceUrl = 'api/yield-curve-data/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.yieldCurveDate = DateUtils.convertDateTimeFromServer(data.yieldCurveDate);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
